import React from 'react';
import { TbListDetails } from "react-icons/tb";
import './Home.css';
import { FaPlus } from 'react-icons/fa';
import { MdOutlineCall, MdOutlineMailOutline } from 'react-icons/md';
import { HomeLogic } from './HomeLogic';
import AddReferralModal from '../AddReferralModal/AddReferralModal';


const HomeMobileUI = () => {
    const {
        showModal,
        users,
        selectedUser,
        filteredData,
        handleOpenReferral,
        handleCloseReferral,
        handleReferralSubmit,
        handleSaveUser,
        handleViewDetails,
        handleUserChange,
    } = HomeLogic();
    const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
    return (

        <div>
            <div className="user-mobile-header">
                <h5 className="user-mobile-header-text">Referral</h5>

                <button onClick={handleOpenReferral} className='add-referreal-btn'>
                    <FaPlus />
                </button>
            </div>

            <div className="main-content-1 ">
                {(accessLevel === 2 || accessLevel === 3) && (
                    <div className="user-select-row-mb ">

                        <label>Select Users</label>
                        <select className="form-select" value={selectedUser} onChange={handleUserChange}>
                            <option value="">All</option>
                            {users.map(user => (
                                <option key={user.username} value={user.username}>
                                    {user.name}
                                </option>
                            ))}
                        </select>

                    </div>
                )}
                <div className={`grid-container-mb ${accessLevel === 2 || accessLevel === 3 ? "with-select-gap" : ""}`}>

                    {filteredData.length > 0 ? (
                        filteredData.map((client, index) => (
                            <div key={index} className="card card-div" onClick={() => handleViewDetails(client)}>
                                <div className="card-header">
                                    {client.firstName} {client.middleName} {client.lastName}
                                </div>
                                <div className="card-body-view">
                                    <p><MdOutlineMailOutline size={18} /> {client.email || "N/A"}</p>
                                    <p><MdOutlineCall className='home-call' size={18} /> {client.phoneNumber || "N/A"}</p>
                                    <span style={{
                                        color:
                                            client.status === 'Install Complete' ? '#28a745' :
                                                client.status === 'Install Scheduled' ? '#fd7e14' :
                                                    client.status === 'Sale Not Made' ? '#dc3545' :
                                                        client.status === 'Pending' ? '#007bff' :
                                                            client.status === 'Customer Requested More Time' ? '#f0ad4e' :
                                                                client.status === 'Unable to reach client' ? '#f1948a' :
                                                                    'inherit',
                                        fontSize: "14px"
                                    }}>
                                        {client.status}
                                    </span>

                                    <div className="hover-view">
                                        <div className="clickable-view">
                                            <span className="view-text-mb">Details</span>
                                            <TbListDetails className="view-icon" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="no-data-message">No referrals.</div>
                    )}
                </div>

                {showModal && (
                    <AddReferralModal onClose={handleCloseReferral} onSave={handleSaveUser} onSubmit={handleReferralSubmit} />
                )}
            </div>
        </div>

    )
}

export default HomeMobileUI
